import AddKnowledge from './components/AddKnowledge';
import Favorite from './components/Favorite';
import NewChatModal from './components/NewChatModal';
import FAQButton from './components/FAQ';
import { HomeOutlined } from '@ant-design/icons';

import './style.css';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const VirtualEngineerButtons = ({ style }) => {
  const navigate = useNavigate();
  const isMobile = window.screen.width < 980;

  return (
    <div className='virtualEngineerButtons' style={style}>
      {/* <FAQButton /> */}

      <Favorite />
      <AddKnowledge />
      <NewChatModal />
      {isMobile && (
        <Button
          icon={<HomeOutlined />}
          size='large'
          style={{
            color: '#2a2a2a',
            border: '#2a2a2a',
            backgroundColor: 'white',
          }}
          onClick={() => {
            navigate('/virtual-engineer');
          }}
        >
          Home
        </Button>
      )}
    </div>
  );
};

export default VirtualEngineerButtons;
